import { useAtomValue } from "jotai";
import { useMemo } from "react";
import { useRecentTimelineInfiniteQuery } from "web_myplann/Api/NotificationCenter/useRecentTimelineInfiniteQuery";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { timelineFilterAtom } from "web_myplann/NotificationCenter/Atoms/timelineFilterAtom";
import { useGroupRecentItems } from "web_myplann/NotificationCenter/Hooks/useGroupRecentItems";

export const useRecentTimelineGroups = (options?: { enabled?: boolean }) => {
	const { t } = useResource();
	const { recentType } = useAtomValue(timelineFilterAtom);
	const query = useRecentTimelineInfiniteQuery({ type: recentType }, options);
	const items = useMemo(
		() => query.data?.pages.flatMap((page) => page.items) ?? [],
		[query.data],
	);
	const groups = useGroupRecentItems(items, t);

	return { query, groups };
};
